import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { logout } from "../api";
import { useUser } from "../contexts";
import { Logo } from "../assets/svgs";
import { useTranslation } from "react-i18next";
import { Button, Menu } from "@mantine/core";
import { MdArrowForwardIos } from "react-icons/md";

const Navbar: React.FC = () => {
  const [scrollTop, setScrollTop] = useState(0);
  const history = useHistory();
  const [user, dispatchUser] = useUser();
  const { t, i18n } = useTranslation();

  const hideNav = (e: any) => {
    if (
      e.target.classList[0] === "nav__link" ||
      e.target.classList[0] === "navbar-dropdown__item" ||
      e.target.classList[0] === "navbar-link"
    ) {
      const nav: any = document.getElementById("nav-toggle");
      nav.checked = false;
    }
  };

  useEffect(() => {
    const onScroll = (e: any) => {
      const navHeight = 56;
      const scrolled = e.target.documentElement.scrollTop;

      if (scrollTop === 0) {
        setScrollTop(scrolled);
        return;
      }

      const navbar: any = document.querySelector(".navbar");

      if (scrolled > navHeight) {
        navbar?.classList.add("animate");
      } else {
        navbar?.classList.remove("animate");
      }



      setScrollTop(scrolled);
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);

  return (
    <div className="navbar">
      <div className="navbar-content">
        <Link
          to="/"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <span className="navbar-content__logo">
            <Logo />
          </span>
        </Link>

        <nav className="navbar-menu">
          <Menu withArrow shadow="md" width={140}>
            <Menu.Target>
              <Button
                rightIcon={<MdArrowForwardIos style={{ rotate: "90deg" }} />}
              >
                {i18n.language.toUpperCase()}
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item
                disabled={i18n.language === "en"}
                onClick={() => {
                  i18n.changeLanguage("en");
                  localStorage.setItem("lang", "en");
                }}
              >
                EN
              </Menu.Item>
              <Menu.Item
                disabled={i18n.language === "de"}
                onClick={() => {
                  i18n.changeLanguage("de");
                  localStorage.setItem("lang", "de");
                }}
              >
                DE
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>

          {user?.user?.isAdmin && (
            <div
              onClick={() => history.push("/dashboard/manufacturers")}
              className="ml-10 navbar-item"
            >
              {t("manufacturers")}
            </div>
          )}

          {user?.user?.isManufacturer && (
            <div
              onClick={() => history.push("/profile")}
              className="ml-10 navbar-item"
            >
              {t("profile")}
            </div>
          )}

          {(user.order.id !== "not_found" || user.user?.id !== "guest") && (
            <div
              onClick={() => {
                logout();
                dispatchUser({ type: "SIGN_OUT" });
                history.push("/");
              }}
              className="ml-10 navbar-item"
            >
              {t("logout")}
            </div>
          )}
        </nav>

        <input
          type="checkbox"
          name=""
          id="nav-toggle"
          className="navbar-content__checkbox"
        />
        <label htmlFor="nav-toggle" className="navbar-content__button show-md">
          <span className="navbar-content__icon">&nbsp;</span>
        </label>
        <div className="navbar-content__overlay show-md">
          <nav onClick={hideNav} className="nav">
            {user.order.id !== "not_found" || user.user?.id !== "guest" ? (
              <>
                <Link to="/" className="nav__link">
                  {t("home")}
                </Link>
                <Link to="/account" className="nav__link">
                  {t("account")}
                </Link>

                <div className="divider--dark" />

                <div
                  onClick={() => {
                    logout();
                    dispatchUser({ type: "SIGN_OUT" });
                    history.push("/");
                  }}
                  className="nav__link"
                >
                  {t("logout")}
                </div>
              </>
            ) : (
              <>
                <div className="navbar-item">
                  <Link to="/" className="navbar-link">
                    {t("home")}
                  </Link>
                </div>
                <div className="navbar-item">
                  <Link to="/login" className="navbar-link">
                    {t("login")}
                  </Link>
                </div>
                <div className="navbar-item">
                  <Link to="/register" className="navbar-link">
                    {t("register")}
                  </Link>
                </div>
              </>
            )}

            <div className="navbar-item mt-20">
              <div className="mobile-lang">
                <span
                  className={`nav__link ${
                    i18n.language === "en" ? "nav-lang-selected" : ""
                  }`}
                  onClick={() => {
                    if (i18n.language === "de") {
                      i18n.changeLanguage("en");
                      localStorage.setItem("lang", "en");
                    }
                  }}
                >
                  En
                </span>
                <span
                  className={`nav__link ${
                    i18n.language === "de" ? "nav-lang-selected" : ""
                  }`}
                  onClick={() => {
                    if (i18n.language === "en") {
                      i18n.changeLanguage("de");
                      localStorage.setItem("lang", "de");
                    }
                  }}
                >
                  De
                </span>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
